var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaloon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0618 15.6696C13.488 12.245 16.8296 10.0103 20.5393 10.0004C24.5444 9.97635 28.1069 12.5407 29.3553 16.3462C30.6038 20.1518 29.2527 24.3281 26.0117 26.6811C22.7707 29.0342 18.3813 29.0259 15.1493 26.6604L12.2793 29.5304C11.9865 29.8229 11.5122 29.8229 11.2193 29.5304C10.9269 29.2376 10.9269 28.7632 11.2193 28.4704L14.0093 25.6804C11.4032 23.0403 10.6356 19.0942 12.0618 15.6696ZM22.86 16.042C23.1041 16.6259 23.6766 17.0045 24.3093 17.0004C25.1654 17.0004 25.8593 16.3065 25.8593 15.4504C25.8634 14.8176 25.4848 14.2451 24.901 14.0011C24.3171 13.7571 23.6437 13.8899 23.1963 14.3374C22.7488 14.7848 22.616 15.4582 22.86 16.042Z",
    fill: "#1B9075"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaloon);
export default __webpack_public_path__ + "static/media/baloon.0c35eb5a866ef112dee37a049fce8d05.svg";
export { ForwardRef as ReactComponent };